import type { WhitelabelVariantDefinition } from '../../types';

export const loclsrchWhitelabel = {
  id: 'loclsrch',
  colors: {
    primary: {
      900: '#004564',
      800: '#005C85',
      700: '#0073A6',
      500: '#4297BD',
      300: '#85BCD4',
      100: '#E5F1F6',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const loclsrchDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: loclsrchWhitelabel.colors.primary[900],
      dark: loclsrchWhitelabel.colors.primary[800],
      main: loclsrchWhitelabel.colors.primary[700],
      light: loclsrchWhitelabel.colors.primary[500],
      lighter: loclsrchWhitelabel.colors.primary[300],
      muted: loclsrchWhitelabel.colors.primary[100],
      contrastText: loclsrchWhitelabel.colors.primary.contrastText,
    },
  },
};
